import {
  REPLENISHMENT_START,
  REPLENISHMENT_END,
  REPLENISHMENT_DELAY_OFF,
  REPLENISHMENT_ERROR,
  REPLENISHMENT_CLEAR_ERROR,
  CABINET_FETCH_START,
  CABINET_FETCH_END,
  CABINET_FETCH_ERROR,
  CABINET_UPDATE,
  CABINET_INVENTORY_FETCH_START,
  CABINET_INVENTORY_FETCH_END,
  CABINET_INVENTORY_FETCH_ERROR,
  CABINET_INVENTORY_UPDATE,
  INVENTORY_CORRECTION_START,
  INVENTORY_CORRECTION_DONE,
  CALIBRATION_START,
  CALIBRATION_START_ERROR,
  CALIBRATION_END,
  CALIBRATION_END_ERROR,
  EMPTY_SHELF_START,
  EMPTY_SHELF_START_ERROR,
  EMPTY_SHELF_END,
  EMPTY_SHELF_END_ERROR,
  INITIAL_SHELF_SLOT_END,
  INITIAL_SHELF_SLOT_END_ERROR,
  INITIAL_SHELF_SLOT_START,
  CANCEL_SLOT_CALIBRATION,
  RECEIVE_CABINET_SHELF_CONFIG_DATA,
} from '../actions/cabinet';

const initialState = {
  fetching: false,
  name: undefined,
  deviceCode: undefined,
  id: undefined,
  group: undefined,
  replenishment: 'off',
  replenishmentDelay: false,
  currentItems: [],
  currentItemsLoading: false,
  error: '',
  deviceSubType: null,
  deviceSubTypeName: 'rfid',
  calibration: 'off',
  calibrationState: null,
  cabinetShelfConfig: {},
  inventoryCorrectionLoading: false,
};

const cabinetReducer = (state = initialState, action) => {
  switch (action.type) {
    case REPLENISHMENT_START:
      return {
        ...state,
        replenishment: 'on',
        replenishmentDelay: true,
      };
    case REPLENISHMENT_DELAY_OFF:
      return {
        ...state,
        replenishmentDelay: false,
      };
    case REPLENISHMENT_END:
      return {
        ...state,
        replenishment: 'off',
      };
    case REPLENISHMENT_CLEAR_ERROR:
      return {
        ...state,
        error: '',
      };
    case REPLENISHMENT_ERROR:
      return {
        ...state,
        error: action.error,
      };
    case CABINET_FETCH_START:
      return {
        ...state,
        fetching: true,
        name: undefined,
        deviceCode: undefined,
      };
    case CABINET_FETCH_END:
      return {
        ...state,
        fetching: false,
      };
    case CABINET_FETCH_ERROR:
      return {
        ...state,
        fetching: false,
        error: action.error,
      };
    case CABINET_UPDATE:
      return {
        ...state,
        name: action.name,
        deviceCode: action.deviceCode,
        id: action.id,
        group: action.organizationId,
        deviceSubType: action.deviceSubType,
        deviceSubTypeName: action.deviceSubTypeName,
      };
    case CABINET_INVENTORY_FETCH_START:
      return {
        ...state,
        currentItemsLoading: true,
      };
    case CABINET_INVENTORY_FETCH_END:
      return {
        ...state,
        currentItemsLoading: false,
      };
    case CABINET_INVENTORY_FETCH_ERROR:
      return {
        ...state,
        currentItemsLoading: false,
        error: action.error,
      };
    case INVENTORY_CORRECTION_START:
      return {
        ...state,
        inventoryCorrectionLoading: true,
      };
    case INVENTORY_CORRECTION_DONE:
      return {
        ...state,
        inventoryCorrectionLoading: false,
      };
    case CABINET_INVENTORY_UPDATE:
      return {
        ...state,
        currentItems: [...action.items],
      };
    case CALIBRATION_START:
      return {
        ...state,
        calibration: 'on',
        calibrationState: 'start',
      };
    case CALIBRATION_START_ERROR:
      return {
        ...state,
        error: action.error,
      };
    case EMPTY_SHELF_START:
      return {
        ...state,
        calibrationState: 'emptyShelfStart',
      };
    case EMPTY_SHELF_START_ERROR:
      return {
        ...state,
        error: action.error,
      };
    case EMPTY_SHELF_END:
      return {
        ...state,
        calibrationState: 'emptyShelfEnd',
      };
    case EMPTY_SHELF_END_ERROR:
      return {
        ...state,
        error: action.error,
      };
    case INITIAL_SHELF_SLOT_END:
      return {
        ...state,
        calibrationState: 'initialSlotEnd',
      };
    case INITIAL_SHELF_SLOT_END_ERROR:
      return {
        ...state,
        error: action.error,
      };
    case INITIAL_SHELF_SLOT_START:
      return {
        ...state,
        calibrationState: 'initalSlotStart',
      };
    case CANCEL_SLOT_CALIBRATION:
      return {
        ...state,
        calibrationState: 'cancelSlotCalibration',
      };
    case CALIBRATION_END:
      return {
        ...state,
        calibration: 'off',
      };
    case CALIBRATION_END_ERROR:
      return {
        ...state,
        error: action.error,
      };
    case RECEIVE_CABINET_SHELF_CONFIG_DATA: {
      return {
        ...state,
        cabinetShelfConfig: action.config,
      };
    }
    default:
      return state;
  }
};

export default cabinetReducer;
